import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import jobs from '../jobs';

export default function MemberInfoPage() {
    const { id } = useParams();
    const [info, setInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchMember() {
            try {
                const res = await axios.get(`/api/manage/users/${id}`);
                setInfo(res.data);
            } catch (err) {
                console.error("멤버 정보를 불러오지 못했습니다.", err);
            } finally {
                setLoading(false);
            }
        }
        fetchMember();
    }, [id]);

    if (loading) {
        return <div style={{ textAlign: "center", marginTop: 60 }}>로딩 중...</div>;
    }
    if (!info) {
        return <div style={{ textAlign: "center", marginTop: 60, color: "#ff4d4f" }}>유저 정보를 불러올 수 없습니다.</div>;
    }

    function handleExtend(months) {
        if (window.confirm(`${months}개월 연장하시겠습니까?`)) {
            let baseDate = info.membership && !isNaN(new Date(info.membership))
                ? new Date(info.membership)
                : new Date();
            // 만료일이 과거면 현재로
            if (baseDate < new Date()) baseDate = new Date();

            const monthsToMs = months * 30 * 24 * 60 * 60 * 1000;
            baseDate = new Date(baseDate.getTime() + monthsToMs);

            axios.post(`/api/manage/users/${id}/membership`, { membership: baseDate.toISOString() })
                .then(() => {
                    alert(`${months}개월 연장이 완료되었습니다.`);
                    window.location.reload();
                })
                .catch(err => {
                    console.error("연장 실패: ", err);
                    alert("연장에 실패했습니다. 다시 시도해주세요.");
                });
        }
    }

    return (
        <div style={{ maxWidth: 700, margin: "40px auto", fontFamily: "sans-serif" }}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>유저 상세정보</h2>
            <table style={{ width: "100%", borderCollapse: "collapse", background: "#fafbfc", borderRadius: 8, overflow: "hidden" }}>
                <tbody>
                    <tr>
                        <th style={thStyle}>이름</th>
                        <td style={tdStyle}>{info.name}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>전화번호</th>
                        <td style={tdStyle}>{info.phone}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>멤버십</th>
                        <td style={tdStyle}>
                            {info.membership && !isNaN(new Date(info.membership)) 
                            ? new Date(info.membership).toLocaleDateString() 
                            : "-"
                            }
                        </td>
                    </tr>
                    <tr>
                        <th style={thStyle}></th>
                        <td style={tdStyle}>
                            <button
                                style={{border: 'none', outline: '1px solid #aaa', borderRadius: 8, padding: '6px 16px', backgroundColor: '#eee', fontWeight: 500, marginRight: 5}}
                                onClick={() => handleExtend(1)}
                            >+ 1개월</button>
                            <button
                                style={{border: 'none', outline: '1px solid #aaa', borderRadius: 8, padding: '6px 16px', backgroundColor: '#eee', fontWeight: 500, marginRight: 5}}
                                onClick={() => handleExtend(3)}
                            >+ 3개월</button>
                            <button
                                style={{border: 'none', outline: '1px solid #aaa', borderRadius: 8, padding: '6px 16px', backgroundColor: '#eee', fontWeight: 500, marginRight: 5}}
                                onClick={() => handleExtend(6)}
                            >+ 6개월</button>
                            <button
                                style={{border: 'none', outline: '1px solid #aaa', borderRadius: 8, padding: '6px 16px', backgroundColor: '#eee', fontWeight: 500, marginRight: 5}}
                                onClick={() => handleExtend(12)}
                            >+ 1년</button>
                            <button
                                style={{border: 'none', outline: '1px solid #aaa', borderRadius: 8, padding: '6px 16px', backgroundColor: '#eee', fontWeight: 500, marginRight: 5}}
                                onClick={() => handleExtend(36)}
                            >+ 3년</button>
                        </td>
                    </tr>
                    <tr>
                        <th style={thStyle}>계정 타입</th>
                        <td style={tdStyle}>{info.type === 1 ? "멤버십 유저" : "일반 유저"}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>가입일</th>
                        <td style={tdStyle}>{new Date(info.createdAt).toLocaleDateString()}</td>
                    </tr>
                </tbody>
            </table>
            {info.type === 1 && info.member && (
                <div style={{ marginTop: 40 }}>
                    <h3 style={{ marginBottom: 16 }}>멤버 정보</h3>
                    <table style={{ width: "100%", borderCollapse: "collapse", background: "#fff", borderRadius: 8 }}>
                        <tbody>
                            <tr>
                                <th style={thStyle}>회사명</th>
                                <td style={tdStyle}>{info.member.companyName}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>대표전화</th>
                                <td style={tdStyle}>{info.member.mainPhone}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>휴대전화</th>
                                <td style={tdStyle}>{info.member.mobilePhone}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>팩스번호</th>
                                <td style={tdStyle}>{info.member.faxNum}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>주소</th>
                                <td style={tdStyle}>{info.member.address}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>지역</th>
                                <td style={tdStyle}>{(info.member.locales || []).join(", ")}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>업종</th>
                                <td style={tdStyle}>
                                    {(info.member.jobs || [])
                                        .map(code => {
                                            const job = jobs.find(j => j.key === code);
                                            return job ? job.label : code;
                                        })
                                        .join(", ")
                                    }
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle}>이메일</th>
                                <td style={tdStyle}>{info.member.email}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>사업자번호</th>
                                <td style={tdStyle}>{info.member.registrationNum}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>사업자등록증</th>
                                <td style={tdStyle}>
                                    {info.member.registrationFile ? (
                                        <a href={`/api/manage/members/${info.member.id}/file`} target="_blank" rel="noopener noreferrer">
                                            {info.member.registrationFile}
                                        </a>
                                    ) : "없음"}
                                </td>
                            </tr>
                            <tr>
                                <th style={thStyle}>가입일</th>
                                <td style={tdStyle}>{new Date(info.member.createdAt).toLocaleDateString()}</td>
                            </tr>
                            <tr>
                                <th style={thStyle}>평점</th>
                                <td style={tdStyle}>{info.member.rating ?? "-"}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
            <div style={{ display: "flex", justifyContent: "center", marginTop: 40 }}>
                <button
                    style={{
                        background: "#ff4d4f",
                        color: "#fff",
                        border: "none",
                        borderRadius: 8,
                        padding: "12px 40px",
                        fontWeight: 600,
                        fontSize: 16,
                        cursor: "pointer"
                    }}
                    onClick={() => {
                        if (window.confirm(`정말로 멤버(${info.name}, ${id})를 삭제하시겠습니까?`)) {
                            axios.delete(`/api/manage/users/${id}`)
                                .then(() => window.location.href = "/users")
                                .catch(err => alert("삭제 실패: " + err.message));
                            alert("삭제되었습니다.");
                        }
                    }}
                >
                    멤버 삭제
                </button>
                {info.type === 1 && info.member && (
                    <div>
                        <div style={{marginRight: 10, display:'inline-block'}}></div>
                        <button
                            style={{
                                background: "#fff3f4ff",
                                color: "#ff4d4f",
                                border: "none",
                                borderRadius: 8,
                                padding: "12px 40px",
                                fontWeight: 600,
                                fontSize: 16,
                                cursor: "pointer",
                                outline: "1px solid #ff4d4f"
                            }}
                            onClick={() => {
                                if (window.confirm(`정말로 멤버(${info.name}, ${id})를 일반 유저로 전환하시겠습니까?`)) {
                                    axios.post(`/api/manage/users/${id}/normalize`)
                                        .then(() => {window.location.href = "/users"; alert("멤버가 일반 유저로 전환되었습니다.");})
                                        .catch(err => { alert("삭제 실패: "); console.error(err.message); });
                                    alert("전환되었습니다.");
                                }
                            }}
                        >
                            일반 유저로 전환
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

const thStyle = {
    background: "#f5f6fa",
    textAlign: "left",
    padding: "10px 8px",
    fontWeight: 600,
    width: 120,
    borderBottom: "1px solid #e1e1e1"
};

const tdStyle = {
    padding: "10px 8px",
    borderBottom: "1px solid #f0f0f0"
};